import { IWeaponLicenceConditionsDetailed } from 'models/legalEntity';
import { hasProperty } from 'utils/typeGuards';

export const hasExtendedConditions = (
  conditions: unknown,
): conditions is IWeaponLicenceConditionsDetailed => {
  if (!conditions || typeof conditions !== 'object') {
    return false;
  }

  const detailedOnlyProps: (keyof IWeaponLicenceConditionsDetailed)[] = [
    'safeStorages',
    'safeStorageDescription',
    'areaOfValidity',
    'weaponCategory',
  ];

  return detailedOnlyProps.some((prop) => hasProperty(conditions, prop));
};
